import React, {MouseEvent} from 'react';

type Props = {
    componentClasses?: string;
    onClick?: (e: MouseEvent<HTMLDivElement>) => void;
    onMouseDown?: (e: MouseEvent<HTMLDivElement>) => void;
    alt: string;
    img: string;
};

export const ImgButton = (props: Props) => {
    const {componentClasses, onClick, onMouseDown, alt, img} = props;
    return (
        <div className={componentClasses} onClick={onClick} onMouseDown={onMouseDown}>
            <img alt={alt} src={img} />
        </div>
    );
};

export default ImgButton;
